export * from './app-sidebar.component';



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar/index.ts